"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withResizeDetectWrapper = exports.withResizeDetect = exports.ResizeDetect = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssElementQueries = require("css-element-queries");
var _ReactComponent = _interopRequireDefault(require("../../PropTypes/ReactComponent"));
var _getDisplayName = _interopRequireDefault(require("../getDisplayName"));
var _excluded = ["onSizeChange", "WrapperComponent"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  size: {
    width: 0,
    height: 0
  }
};
var ResizeDetectContext = /*#__PURE__*/_react["default"].createContext(initialState);

/**
 * Wrap a component with the ResizeSensor
 * Usage modes:
 *  1. children prop is the wrapped component
 *      -> add a container around it and apply the ResizeSensor on the wrapper container
 *  2. children prop is a render prop
 *      -> define the dom element reference for the ResizeSensor container inside the render prop with containerRef
 */
var ResizeDetect = exports.ResizeDetect = /*#__PURE__*/function (_React$Component) {
  _inherits(ResizeDetect, _React$Component);
  var _super = _createSuper(ResizeDetect);
  function ResizeDetect() {
    var _this;
    _classCallCheck(this, ResizeDetect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", initialState);
    _defineProperty(_assertThisInitialized(_this), "updateState", function () {
      var container = _this.getContainer();
      var _container$getBoundin = container.getBoundingClientRect(),
        width = _container$getBoundin.width,
        height = _container$getBoundin.height;
      var size = {
        width: Math.floor(width),
        height: Math.floor(height)
      };
      _this.setState({
        size: size
      });
      var onSizeChange = _this.props.onSizeChange;
      onSizeChange && onSizeChange(size);
    });
    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/_react["default"].createRef());
    return _this;
  }
  _createClass(ResizeDetect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = this.getContainer();
      this.resizeSensor = new _cssElementQueries.ResizeSensor(container, this.updateState);
      // trigger change for the first time
      this.updateState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // releasing resize sensor
      this.resizeSensor.detach();
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      var container = this.containerRef.current;
      if (!container) {
        throw new TypeError('ResizeDetect can only work with children as a render prop or with the wrapper mode on.');
      }
      return container;
    }
  }, {
    key: "getProps",
    value: function getProps() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
        onSizeChange = _this$props.onSizeChange,
        WrapperComponent = _this$props.WrapperComponent,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return otherProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        WrapperComponent = _this$props2.WrapperComponent,
        wrapperClassName = _this$props2.wrapperClassName,
        wrapperProps = _this$props2.wrapperProps;
      var Container = WrapperComponent || 'div';
      return typeof children !== 'function' ? /*#__PURE__*/_react["default"].createElement(ResizeDetectContext.Provider, {
        value: this.state
      }, /*#__PURE__*/_react["default"].createElement(Container, _extends({
        className: wrapperClassName,
        ref: this.containerRef
      }, wrapperProps), children)) : children({
        containerRef: this.containerRef,
        size: this.state.size,
        containerProps: this.getProps()
      });
    }
  }]);
  return ResizeDetect;
}(_react["default"].Component);
/**
 * HOC for the 2. usage mode (provides the Component as a render function directly, so it can get the props)
 * Hint: in this case don't forget to use the containerRef inside the component to define the container element
 * for the ResizeSensor.
 * @param Component
 */
var withResizeDetect = exports.withResizeDetect = function withResizeDetect(Component) {
  var WithResizeDetect = function WithResizeDetect() {
    return /*#__PURE__*/_react["default"].createElement(ResizeDetect, null, function (props) {
      return /*#__PURE__*/_react["default"].createElement(Component, props);
    });
  };
  WithResizeDetect.displayName = "WithResizeDetect(".concat((0, _getDisplayName["default"])(Component), ")");
  return WithResizeDetect;
};

/**
 * HOC for the 1. usage mode (adds a wrapper div around the component)
 * @param Component
 */
var withResizeDetectWrapper = exports.withResizeDetectWrapper = function withResizeDetectWrapper(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(ResizeDetect, props, /*#__PURE__*/_react["default"].createElement(ResizeDetectContext.Consumer, null, function (state) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, state, props));
    }));
  };
};